export default __webpack_public_path__ + "static/media/321.c2bb3dad.png";